import { Box, List, ListItem, Typography } from '@mui/material'
import React from 'react'
import ChairTitle from '../atoms/ChairTitle'
import useMissions from '../../hooks/useMissions'

const OurMissions = () => {
	const { missions } = useMissions()

	return (
		<Box
			sx={(theme) => ({
				mt: 8,
				mx: 2,
			})}
		>
			<ChairTitle label="Nos missions" />
			<List
				sx={(theme) => ({
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					color: 'text.primary',
					[theme.breakpoints.down('md')]: {
						flexDirection: 'column',
					},
				})}
			>
				{missions &&
					missions.map(({ description: mission }, index) => (
						<ListItem
							key={index}
							sx={(theme) => ({
								flexDirection: 'column',
								p: 0,
								[theme.breakpoints.down('md')]: {
									flexDirection: 'row',
									alignItems: 'baseline',
									justifyContent: 'flex-start',
								},
								'&:not(:first-of-type)': {
									pl: 6,
									[theme.breakpoints.down('md')]: {
										pl: 0,
									},
								},
								'& b': {
									textDecoration: 'underline',
								},
							})}
						>
							<Typography
								component="h6"
								sx={(theme) => ({
									fontSize: 56,
									fontWeight: 800,
									color: 'secondary.main',
									display: 'block',
									width: '100%',

									[theme.breakpoints.down('md')]: {
										fontSize: 20,
										width: 0,
										pr: 4,
									},
								})}
							>
								{index + 1}.
							</Typography>
							<Typography
								component="p"
								sx={(theme) => ({
									fontSize: 18,
									'& strong': {
										textDecoration: 'underline',
									},
									[theme.breakpoints.down('md')]: {
										fontSize: 16,
									},
								})}
								dangerouslySetInnerHTML={{ __html: mission }}
							></Typography>
						</ListItem>
					))}
			</List>
		</Box>
	)
}

export default OurMissions
